import { NuxtAxiosInstance } from 'vue/types/vue';
import { DiscoverApiService, DiscoverListRequest } from '~/api/discover';
import { ABTestApi } from '@/api/ab-test';

export const getDiscoverList = async (
    data: DiscoverListRequest,
    url: string,
    discoverApiService: DiscoverApiService,
    axios?: NuxtAxiosInstance,
    store?: Record<string, any>
) => {
    const hasFetched = store?.state?.seoDiscoverFilterStrategy?.status === 200;

    if (!hasFetched) {
        const discoverFilterStrategy = await ABTestApi.getABTestConfig({
            url,
            parameter: 'seo_default_filter_v3',
        });
        store?.commit('setSeoDiscoverFilterStrategy', discoverFilterStrategy);
    }

    const seoDefaultFilterV2 = store?.state?.seoDiscoverFilterStrategy?.data?.value === 'true';
    data.seoDefaultFilterV2 = seoDefaultFilterV2;
    const res = await discoverApiService.getDiscoverList(data);

    return res;
};
